var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/toggle_screen_light_gray.9d02b958.png","uri@3x": __webpack_public_path__ + "static/media/toggle_screen_light_gray.ba5ad475.png","uri@2x": __webpack_public_path__ + "static/media/toggle_screen_light_gray.bee36e6c.png",
    width: 60,
    height: 60
});